import React from "react";
import styles from "./index.module.scss";
import { StatCardProps } from "../types";

const StatCard: React.FC<StatCardProps> = ({ cardData, icon, handleClick }) => {
  const { count, displayName, highlighted } = cardData;

  const onClick = () => {
    if (handleClick) {
      handleClick(cardData);
    }
  };

  return (
    <div className={styles.statCard} onClick={onClick}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.details}>
        <span
          className={`${styles.count} ${highlighted ? styles.highlighted : ""}`}
        >
          {count}
        </span>
        <span className={styles.label}>{displayName}</span>
      </div>
    </div>
  );
};

export default StatCard;
